// extracted by mini-css-extract-plugin
module.exports = {"questionnaireLayout":"QuestionnaireLayout_questionnaireLayout__1p7lN","footer":"QuestionnaireLayout_footer__MjTfC"};